// extracted by mini-css-extract-plugin
export default {"root":"Logout_root__GAKwL","logout":"Logout_logout__2lrQb"};